import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import { DEFAULT_LANGUAGE } from '../config/locale/locale';
import type { LanguageType } from '../constants/enums';

export interface LocaleState {
  language: LanguageType;
}

export const initialLocaleState: LocaleState = {
  language: DEFAULT_LANGUAGE,
};

const localeSlice = createSlice({
  name: 'locale',
  initialState: initialLocaleState,
  reducers: {
    setLanguage: (state, action: PayloadAction<LanguageType>) => {
      state.language = action.payload;
    },
  },
});

export const { setLanguage } = localeSlice.actions;
export const localeReducer = localeSlice.reducer;
